import config from "@/config";
import { router } from "@/router";
import { userService } from "@/services";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapState } from "vuex";
import { VueRecaptcha } from "vue-recaptcha";
import { Account } from "@/models/account.model";

@Component({
  computed: {
    ...mapState("account", ["user"]),
  },
  components: {},
  metaInfo: {
    title: "Registreren",
    meta: [
      {
        vmid: "description",
        name: "description",
        content: "Registreer je voor de Beround Superelf",
      },
    ],
  },
})
export default class Profile extends Vue {
  public user!: Account;
  account: Account = {} as any;
  loaded = false;
  edit = false;

  submitted = false;
  showPassword = false;
  showConfirm = false;

  register!: (model: any) => any;
  logout!: () => any;

  async created() {
    this.account = await userService.getById(this.user.id);
    this.loaded = true;
  }

  onSubmit() {
    this.submitted = true;
    //@ts-ignore
    this.$refs.recaptcha.execute();
  }

  async save() {
    userService
      .update(this.account)
      .then(() => {
        store.dispatch("alert/success", "Account is opgeslagen");
      })
      .finally(() => {
        this.edit = false;
      });
  }
}
